import { FormBuilder, FormGroup } from '@angular/forms';
import { PropertiesSettings } from "../../core/configuration/properties-settings";
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { AltraparteAssociativaAdapter } from '../components/fascicolo/altre-parti-update/altra-parte-adapter';
import { AltraParte } from '../models/altraparte';
import { Controparte } from '../models/controparte';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { Parte } from '../models/parte';
import { Categoria } from '../models/tipologiche/categoria';
import { BaseForm } from './base-Form';

declare var removeEmptyObject: any;

export abstract class AssociativaAltrePartiForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  associativaForm: FormGroup;
  categorie: Categoria[] = [];
  request: AltraParte;
  parte: Parte;
  controparti: Controparte[] = [];

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

 createForm() {
    let altraParte: AltraParte = this.getAltraParte();
    if (this.parte) {
      altraParte.parte = this.parte;
    }
    this.request = new AltraparteAssociativaAdapter(altraParte).altraParte;
    if(!this.request.dataAssociazione){
      this.request.dataAssociazione=new Date().getTime();
    }
    this.associativaForm = this.campiForm.group({
      categoriaAltraParte: [this.request.categoriaAltraParte],
      cliente: [this.request.cliente],
      //dataAssociazione: [this.request.dataAssociazione, Validators.required],
      dataTermine: [this.request.dataTermine],
      ritirato: [this.request.ritirato],
      controparte:[{value: this.request.controparte, disabled: true}],
      note: [this.request.note]
    });
  }

  populateSelect(urlSezioneControparti: string, idSezioneControparti: string) {
    if (this.categorie.length === 0) {
      this.helpers.getCategorieAltraParte().subscribe(response => this.categorie = response);
    }

    if (idSezioneControparti && this.controparti.length === 0) {
      this.operationService.readSezione(urlSezioneControparti, idSezioneControparti)
      .subscribe(response => this.controparti = (<SezioneContropartiResponse>response).sezione.controparti);
    }
  }

  categoriaAltraParteChanged(newCategoria: Categoria) {
    this.request.categoriaAltraParte = newCategoria;
    this.request.controparte = null;
  }

  update() {
    this.getRequest(this.request);
  }

  setParte(parte: Parte) {
    this.parte = parte;
  }

  abstract getAltraParte(): AltraParte;
  abstract getRequest(request: AltraParte);
}
